import i18n from '@/i18n';
import {DeviceType} from '@/services/graphqlHooks';

const pairedDeviceTypes = {
  [DeviceType.Mobile]: i18n.t('Mobile'),
  [DeviceType.Computer]: i18n.t('Computer'),
} as Record<DeviceType, string>;

export default pairedDeviceTypes;
